var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',_vm._g({ref:"map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.mapOptions}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }